export const MAX_LOCALITIES = 3;
export const MAX_STORES = 2;

export const HIGHLIGHT_PREFIX = "<span>";
export const HIGHLIGHT_POSTFIX = "</span>";
